module.exports = __webpack_public_path__ + "img/Setembro_Amarelo630x400.c0b7972e.jpg";